"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var inputable_1 = require("../decorators/inputable");

var withStyles_1 = require("../decorators/withStyles");

var withField_1 = require("../decorators/withField");

var Input_styles_1 = require("./Input.styles");

var withResponsive_1 = require("../decorators/withResponsive");

var mobileStylesHelper_1 = require("../assets/mobileStylesHelper");

var Icon_1 = require("../Icon/Icon");

var show_svg_1 = require("svgson-loader!mrg-icons/src/mailru/actions/show.svg");

var hide_svg_1 = require("svgson-loader!mrg-icons/src/mailru/actions/hide.svg");

var handleEvent_1 = require("../assets/handleEvent");

var inputAttrs_1 = require("../assets/inputAttrs");

var classNames = require("classnames");

var Input =
/** @class */
function (_super) {
  __extends(Input, _super);

  function Input() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Input.prototype.render = function () {
    var _a;

    var _b = this.props,
        classes = _b.classes,
        type = _b.type,
        togglePasswordMask = _b.togglePasswordMask,
        passwordMaskVisibility = _b.passwordMaskVisibility,
        onTogglePasswordMask = _b.onTogglePasswordMask,
        pattern = _b.pattern;
    var passwordEye = type === 'password' && togglePasswordMask;
    var inputType = type;

    if (passwordEye) {
      inputType = passwordMaskVisibility ? 'password' : 'text';
    }

    var className = classNames(classes.input, (_a = {}, _a[classes.withIcon] = togglePasswordMask, _a));
    return React.createElement("div", {
      className: mobileStylesHelper_1.createMobileClasses(this.props)
    }, React.createElement("input", __assign({}, inputAttrs_1.inputAttrs(this.props), {
      type: inputType,
      pattern: pattern,
      className: className
    })), passwordEye && React.createElement("div", {
      "data-test-id": "toggle-password-mask",
      className: classes.passwordEye,
      onClick: handleEvent_1.handleEvent.bind(null, onTogglePasswordMask, !passwordMaskVisibility)
    }, React.createElement(Icon_1.default, {
      icon: passwordMaskVisibility ? show_svg_1.default : hide_svg_1.default
    })));
  };

  Input = __decorate([withResponsive_1.withResponsive, withField_1.withField, inputable_1.inputable, withStyles_1.withStyles(Input_styles_1.styles)], Input);
  return Input;
}(React.PureComponent);

exports.default = Input;